import L from  'leaflet';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
    iconUrl: icon,
    iconRetinaUrl: iconRetina,
    shadowUrl: iconShadow,
    iconSize: [25,41],
    iconAnchor: [12,41],
});

L.Marker.prototype.options.icon = DefaultIcon; //takich rzeczy sie nie robi ale to jest zmian domyslnej ikony która działa